import React from "react";

import Box from "veneer/Box";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

import { StructuralWidgetProps, getWidgetConfigString } from "./widgetConfig";

export default function SectionHeadingWidget({
  config,
}: StructuralWidgetProps) {
  const title = getWidgetConfigString(config, "title", "Section heading");
  const description = getWidgetConfigString(config, "description", "");

  return (
    <Box alignSelf="center" px={1} width="100%">
      <Typography variant="h3">{title}</Typography>
      {description && (
        <Typography color={Colors.gray700} variant="body2">
          {description}
        </Typography>
      )}
    </Box>
  );
}
